import React, { createContext, useContext, ReactNode } from 'react';
import { useWindowShortcuts } from '../hooks';
import logger from '../services/logger';

// Create a context for keyboard shortcuts
export const ShortcutsContext = createContext<ReturnType<typeof useWindowShortcuts> | null>(null);

// Custom hook to use shortcuts context
export const useShortcutsContext = () => {
  const context = useContext(ShortcutsContext);
  if (!context) {
    throw new Error('useShortcutsContext must be used within a KeyboardShortcutsProvider');
  }
  return context;
};

interface KeyboardShortcutsProviderProps {
  children: ReactNode;
}

// Provider component that wraps app and provides shortcuts context
export const KeyboardShortcutsProvider: React.FC<KeyboardShortcutsProviderProps> = ({ children }) => {
  // Use our window shortcuts hook to handle keyboard shortcuts
  const shortcuts = useWindowShortcuts();
  
  // Log that shortcuts are initialized
  React.useEffect(() => {
    logger.info('Keyboard shortcuts initialized', { module: 'shortcuts' });
  }, []);
  
  // Provide shortcuts to the entire app
  return (
    <ShortcutsContext.Provider value={shortcuts}>
      {children}
    </ShortcutsContext.Provider>
  );
};

export default KeyboardShortcutsProvider; 